import { render, staticRenderFns } from "./ModalC.vue?vue&type=template&id=1837ad30&"
import script from "./ModalC.vue?vue&type=script&lang=js&"
export * from "./ModalC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports